import React from 'react';
import missionBg from '../../../assets/site/bg-mission.jpg';
import Section from '../../site/components/Section';
import { missionStatement, missionValues } from '../../site/data/content';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import styles from './Mission.module.css';

const Mission = () => (
  <Section id="mission" background={missionBg} backgroundPosition="center 62%">
    <div className={cx(ui.wrap, styles.grid)}>
      <div data-reveal="">
        <span className={ui.eyebrow}>Our mission</span>
        <p className={styles.statement}>{missionStatement}</p>
      </div>
      <div className={styles.values}>
        {missionValues.map((value, index) => (
          <div
            key={value.title}
            className={cx(styles.value, index % 2 === 0 ? ui.glass : ui.matte)}
            data-tilt=""
            data-reveal=""
          >
            <div>
              <h3>{value.title}</h3>
              <p>{value.text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </Section>
);

export default Mission;
